import { render, staticRenderFns } from "./WalletAdminTransactionsTable.vue?vue&type=template&id=3e3a2eb0&scoped=true&"
import script from "./WalletAdminTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./WalletAdminTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./WalletAdminTransactionsTable.vue?vue&type=style&index=0&id=3e3a2eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a2eb0",
  null
  
)

export default component.exports